<template>
  <footer class="footer px-4 mx-2">
    <b-row align-v="center" class="justify-content-lg-between">
      <b-col lg="4">
        <div class="copyright text-center text-lg-left text-muted">
          © {{year}} <a href="https://www.claritynowre.com" class="font-weight-bold ml-1" target="_blank">ClarityNOW, Inc</a>
        </div>
      </b-col>
      <b-col lg="8">
        <b-nav align="center" class="nav-footer justify-content-lg-end mr-6">
          <b-nav-item href="https://www.claritynowre.com" target="_blank">
            ClarityNOW, Inc
          </b-nav-item>
          <b-nav-item href="https://www.claritynowre.com" target="_blank">
           About Us
          </b-nav-item>
          <b-nav-item href="https://www.claritynowre.com/privacy-policy" target="_blank">
            Privacy
          </b-nav-item>
          <b-nav-item href="https://www.claritynowre.com/terms-and-conditions" target="_blank">
            Terms
          </b-nav-item>
          <b-nav-item v-b-toggle.contact-us>
            Contact Us
          </b-nav-item>
        </b-nav>
      </b-col>
    </b-row>
    <contact-us></contact-us>
  </footer>
</template>
<script>
import ContactUs from '@/views/Components/ContactUs';
export default {
  components: {
    ContactUs
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style>
  #contactBtn {
    margin-bottom: 10px;
  }
  #contactBtn.not-collapsed .fa-angle-up:before {
    content: "\F107";
  }
</style>
